import styled from "styled-components";

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 900;
  color: #000000;
  flex: 1;
  min-width: 0;
`;

export const CountBadge = styled.span`
  font-size: 12px;
  font-weight: 900;
  color: #4a4a4a;
  white-space: nowrap;
`;

export const SubTitle = styled.p`
  margin: 2px 0 0;
  font-size: 12px;
  color: #000000;
  line-height: 16px;
`;

export const ExcelUploadSection = styled.div`
  margin-bottom: 0;
`;

export const ExcelHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
`;

export const ExcelIconWrap = styled.div`
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 5px;
  background: #e6fff9;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    display: block;
  }
`;

export const ExcelHeaderCol = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ExcelTitle = styled.div`
  font-size: 14px;
  font-weight: 900;
  color: #000000;
  margin-bottom: 4px;
  line-height: normal;
`;

export const ExcelDesc = styled.div`
  font-size: 12px;
  color: #4a4a4a;
  line-height: normal;
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 12px 12px 16px;
  background: #f6f6f6;
  border-radius: 16px;
  margin-bottom: 12px;
  height: 56px;
  box-sizing: border-box;
`;

export const ActionRowLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #4a4a4a;
  line-height: normal;
  flex: 1;
  min-width: 0;

  strong {
    font-weight: 700;
  }
`;

const IconBtnBase = styled.button`
  flex-shrink: 0;
  width: 42px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  box-sizing: border-box;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const DownloadIconBtn = styled(IconBtnBase)`
  border: 1px solid #008cff;
  background: #fff;
  color: #008cff;
`;

export const UploadIconBtn = styled(IconBtnBase)`
  border: none;
  background: linear-gradient(92.19deg, #53b2fe 0%, #065af3 100%);
  color: #fff;
`;

export const SectionDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d8d8d8;
  position: relative;
`;

export const OrLabel = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #757575;
`;

export const ManualCta = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  border: none;
  background: none;
  color: #008cff;
  font-weight: 700;
  font-size: 14px;
  padding: 8px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  box-sizing: border-box;

  &:disabled {
    color: #B2B2B2;
    cursor: not-allowed;
  }
`;

/* ---- Error bar ---- */

export const ErrorBar = styled.div`
  background: #fde8e8;
  border-radius: 8px;
  padding: 10px 12px;
  margin-top: 12px;
  font-size: 13px;
  font-weight: 400;
  color: #c62828;
  line-height: 18px;
`;

/* ---- Uploaded file bar ---- */

export const FileBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f2f2f2;
  border-radius: 16px;
  padding: 12px 16px 12px 12px;
`;

export const FileBarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
`;

export const FileName = styled.span`
  font-size: 14px;
  font-weight: 900;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ReUploadBtn = styled.button`
  flex-shrink: 0;
  border: none;
  background: none;
  color: #008cff;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  padding: 8px;
  text-transform: uppercase;
`;

/* ---- Traveller list header ---- */

export const TravellerListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const TravellerListTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #4a4a4a;
`;

export const ViewAllBtn = styled.button`
  border: none;
  background: none;
  color: #008cff;
  font-size: 14px;
  font-weight: 900;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
`;

export const TravellerListWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`;

/* ---- Compact traveller card ---- */

export const TravCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

export const CheckboxBtn = styled.button<{ $checked?: boolean }>`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: ${(p) => (p.$checked ? "none" : "2px solid #9e9e9e")};
  background: ${(p) => (p.$checked ? "#008cff" : "transparent")};
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    display: block;
  }
`;

export const TravInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TravName = styled.div`
  font-size: 16px;
  font-weight: 900;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TravDetails = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 14px;
  color: #4a4a4a;
  white-space: nowrap;
  overflow: hidden;
  flex-wrap: wrap;
`;

export const TravPipe = styled.span`
  color: #cbcbcb;
`;

export const ChevronBtn = styled.button<{ $expanded?: boolean }>`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  transform: ${(p) => (p.$expanded ? "rotate(180deg)" : "rotate(0)")};
  color: #008cff;
`;

export const TravExpandedWrap = styled.div`
  padding: 12px 0 4px 32px;
`;
